"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationType = exports.standingCcScope = exports.reachDays = exports.reachWindow = exports.phoneKind = exports.endpointChannel = exports.routingContactScope = exports.routingBehavior = exports.batchTerminal = exports.batchState = exports.destinationKind = exports.attemptOutcome = exports.notifyChannel = exports.actionCode = exports.noteSourceKind = exports.noteSection = exports.obligationStatus = exports.transitionOutcome = exports.alertState = exports.baselineExclusion = exports.locationSource = exports.timestampResolution = exports.unitResolution = exports.vitalTypeResolution = exports.fhirComponentRole = exports.bpPairStatus = exports.readingGroupKind = exports.bandComparator = exports.bandDirection = exports.plausibilityStatus = exports.autoLane = exports.alertLane = exports.severityBand = exports.bandOxygenStatus = exports.oxygenStatus = exports.vitalCode = exports.principalKind = exports.breakGlassOutcome = exports.purposeOfUse = exports.accessAction = exports.personStatus = exports.affiliationStatus = exports.mnLimitationMethod = exports.mnExceptionBasis = exports.configScopeKind = exports.practiceKind = exports.tenantStatus = exports.accessBasis = exports.accessScopeKind = exports.roleCode = void 0;
exports.changeChannel = exports.changeOperation = exports.enrolmentState = exports.summaryState = exports.summaryKind = exports.routingResolutionStatus = void 0;
// Every pgEnum the RPM domain introduces (docs/rpm/03-RPM-SCHEMA.md §7.2), transcribed in the
// register's own order. Separate from the table files so a new enum value is one reviewable diff.
//
// `audit_action` is NOT here. It is the repository's, declared in schema.ts, and §4.1.4 extends it
// by seven values rather than duplicating it (N11): a pgEnum declares a type, it does not add a
// value to one another file already owns.
const pg_core_1 = require("drizzle-orm/pg-core");
/* --- foundation subset, extended per §4.1 --- */
exports.roleCode = (0, pg_core_1.pgEnum)("role_code", [
    "PHYSICIAN",
    "NURSE_PRACTITIONER",
    "PHYSICIAN_ASSISTANT",
    "MEDICAL_DIRECTOR",
    "SCRIBE",
    "SCHEDULER",
    "CARE_COORDINATOR",
    "CARE_MANAGER",
    "BILLER_CODER",
    "QUALITY_ANALYST",
    "PRACTICE_ADMINISTRATOR",
    "CUSTOMER_ADMINISTRATOR",
    "READ_ONLY_AUDITOR",
    "INTERFACE_SERVICE",
    "PLATFORM_OPERATOR", // +1, CR-12
    "NURSE_LEAD", // +1, CR-43: maintains routing contacts, writes nothing clinical
]);
exports.accessScopeKind = (0, pg_core_1.pgEnum)("access_scope_kind", [
    "TENANT",
    "ORG_UNIT",
    "PRACTICE",
    "CERTIFIED_FACILITY",
    "BUILDING",
    "PLATFORM", // +1, CR-12
]);
exports.accessBasis = (0, pg_core_1.pgEnum)("access_basis", [
    "PANEL_MEMBERSHIP",
    "ATTENDING_OF_RECORD",
    "COVERAGE_ASSIGNMENT",
    "ROUNDING_ASSIGNMENT",
    "SUPERVISION",
    "ADMINISTRATIVE_SCOPE",
    "BREAK_GLASS",
    "RPM_ALERT_ASSIGNMENT", // +1, CR-32
]);
exports.tenantStatus = (0, pg_core_1.pgEnum)("tenant_status", [
    "PROSPECTIVE",
    "ACTIVE",
    "SUSPENDED",
    "TERMINATED",
]);
exports.practiceKind = (0, pg_core_1.pgEnum)("practice_kind", [
    "PHYSICIAN_GROUP",
    "SERVICE_LINE",
    "ROUNDING_GROUP",
    "BEHAVIORAL_HEALTH",
    "CARE_MANAGEMENT",
    "OTHER",
]);
exports.configScopeKind = (0, pg_core_1.pgEnum)("config_scope_kind", [
    "TENANT",
    "PRACTICE",
    "CERTIFIED_FACILITY",
]);
exports.mnExceptionBasis = (0, pg_core_1.pgEnum)("mn_exception_basis", [
    "TREATMENT",
    "TO_THE_INDIVIDUAL",
    "AUTHORIZATION",
    "REQUIRED_BY_LAW",
    "TO_THE_SECRETARY",
]);
exports.mnLimitationMethod = (0, pg_core_1.pgEnum)("mn_limitation_method", [
    "STANDARD_PROTOCOL_ROUTINE_RECURRING",
    "INDIVIDUAL_REVIEW_AGAINST_CRITERIA",
    "RELIANCE_ON_REQUESTOR_REPRESENTATION",
]);
exports.affiliationStatus = (0, pg_core_1.pgEnum)("affiliation_status", [
    "PENDING",
    "ACTIVE",
    "SUSPENDED",
    "TERMINATED",
]);
exports.personStatus = (0, pg_core_1.pgEnum)("person_status", [
    "ACTIVE",
    "INACTIVE",
    "DECEASED",
    "MERGED_AWAY",
]);
exports.accessAction = (0, pg_core_1.pgEnum)("access_action", [
    "VIEW",
    "PRINT",
    "EXPORT",
    "QUERY",
    "TRANSMIT",
]);
exports.purposeOfUse = (0, pg_core_1.pgEnum)("purpose_of_use", [
    "TREATMENT",
    "PAYMENT",
    "OPERATIONS",
    "PATIENT_SAFETY",
    "OTHER",
]);
exports.breakGlassOutcome = (0, pg_core_1.pgEnum)("break_glass_outcome", [
    "APPROPRIATE",
    "INAPPROPRIATE",
    "INDETERMINATE",
]);
exports.principalKind = (0, pg_core_1.pgEnum)("principal_kind", [
    "SCHEDULED_JOB",
    "MIGRATION",
    "DATA_IMPORT",
    "PLATFORM_PROVISIONING",
]); // no INGEST — the form is the only writer of a reading
/* --- clinical vocabulary --- */
exports.vitalCode = (0, pg_core_1.pgEnum)("vital_code", [
    "HR",
    "RR",
    "TEMP",
    "BP_SYSTOLIC",
    "BP_DIASTOLIC",
    "SPO2",
    "ACVPU",
]);
exports.oxygenStatus = (0, pg_core_1.pgEnum)("oxygen_status", ["ROOM_AIR", "ON_OXYGEN", "UNKNOWN"]);
// no UNKNOWN — CR-17. The reading-level oxygenStatus has three values because a nurse may honestly
// not know; the band table has two because the protocol states two. A third would be a stored gray
// boundary, which is the defect this schema exists to remove.
exports.bandOxygenStatus = (0, pg_core_1.pgEnum)("band_oxygen_status", ["ROOM_AIR", "ON_OXYGEN"]);
exports.severityBand = (0, pg_core_1.pgEnum)("severity_band", ["CRITICAL", "CONCERNING", "CLEAR", "GRAY"]);
// autoLane has GRAY and alertLane does not: two enums rather than one with a check constraint, so
// the impossible state is unrepresentable in the type drizzle-zod projects into the API contract.
exports.alertLane = (0, pg_core_1.pgEnum)("alert_lane", ["CRITICAL", "CONCERNING", "CLEAR", "MACHINE"]);
exports.autoLane = (0, pg_core_1.pgEnum)("auto_lane", ["CRITICAL", "CONCERNING", "CLEAR", "MACHINE", "GRAY"]);
exports.plausibilityStatus = (0, pg_core_1.pgEnum)("plausibility_status", ["PLAUSIBLE", "IMPLAUSIBLE"]);
exports.bandDirection = (0, pg_core_1.pgEnum)("band_direction", ["LOW", "HIGH"]);
exports.bandComparator = (0, pg_core_1.pgEnum)("band_comparator", ["LT", "GT"]);
exports.readingGroupKind = (0, pg_core_1.pgEnum)("reading_group_kind", ["BP_PAIR"]);
exports.bpPairStatus = (0, pg_core_1.pgEnum)("bp_pair_status", [
    "COMPLETE",
    "PARTIAL_SYSTOLIC_ONLY",
    "PARTIAL_DIASTOLIC_ONLY",
    // Both halves captured, and a captured half not scored — outside its bounds, or in a unit that did
    // not resolve (`CR-42`, `J-423`). `COMPLETE` is what a reader takes to mean both halves count.
    "CAPTURED_HALF_UNSCORED",
]);
exports.fhirComponentRole = (0, pg_core_1.pgEnum)("fhir_component_role", ["SYSTOLIC", "DIASTOLIC"]);
exports.vitalTypeResolution = (0, pg_core_1.pgEnum)("vital_type_resolution", [
    "EXPLICIT_WORD",
    "VALUE_SHAPE",
    "NURSE_PICKED",
    "AMBIGUOUS",
]);
exports.unitResolution = (0, pg_core_1.pgEnum)("unit_resolution", ["CANONICAL", "ALIASED", "UNRESOLVABLE"]);
exports.timestampResolution = (0, pg_core_1.pgEnum)("timestamp_resolution", [
    "RESOLVED",
    "UNRESOLVED_UNPARSEABLE",
    "UNRESOLVED_FACILITY_ZONE",
    "UNRESOLVED_DST_GAP",
    "UNRESOLVED_DST_AMBIGUOUS", // CR-15
]);
exports.locationSource = (0, pg_core_1.pgEnum)("location_source", ["NURSE_ENTERED", "MIRROR_DERIVED"]);
exports.baselineExclusion = (0, pg_core_1.pgEnum)("baseline_exclusion_reason", [
    "DEVICE_ERROR",
    "CORRECTED",
    "POST_INTERVENTION",
    "CARE_EPISODE_BOUNDARY",
]);
exports.alertState = (0, pg_core_1.pgEnum)("alert_state", [
    "INTAKE",
    "CLASSIFIED",
    "BLOCKED",
    "CLEARED",
    "NOTIFY_OWED",
    "CLOSED",
    "SUPERSEDED",
]);
exports.transitionOutcome = (0, pg_core_1.pgEnum)("transition_outcome", [
    "TRANSITIONED",
    "REFUSED",
    "IGNORED",
]);
exports.obligationStatus = (0, pg_core_1.pgEnum)("obligation_status", ["NONE", "OWED", "MET", "UNMET"]);
exports.noteSection = (0, pg_core_1.pgEnum)("note_section", [
    "SITUATION",
    "BACKGROUND",
    "ASSESSMENT",
    "RECOMMENDATION",
]);
exports.noteSourceKind = (0, pg_core_1.pgEnum)("note_source_kind", ["CAPTURED", "DERIVED", "FREE_TEXT"]);
exports.actionCode = (0, pg_core_1.pgEnum)("action_code", ["WILL_EMAIL", "CALLED", "WILL_SUMMARIZE"]);
/* --- notification vocabulary --- */
exports.notifyChannel = (0, pg_core_1.pgEnum)("notify_channel", ["PHONE", "TEXT", "EMAIL", "EMR_MESSAGE"]);
exports.attemptOutcome = (0, pg_core_1.pgEnum)("attempt_outcome", [
    "REACHED",
    "NO_ANSWER",
    "TEXTED",
    "EMAILED",
]);
exports.destinationKind = (0, pg_core_1.pgEnum)("destination_kind", [
    "PHONE_NUMBER",
    "EXTENSION",
    "EMAIL_ADDRESS",
    "EMR_ENDPOINT",
]);
exports.batchState = (0, pg_core_1.pgEnum)("batch_state", ["PENDING", "ATTEMPTING", "CLOSED"]);
// CR-10: never NO_ANSWER
exports.batchTerminal = (0, pg_core_1.pgEnum)("batch_terminal_outcome", ["REACHED", "TEXTED", "EMAILED"]);
/* --- communication routing (CR-43) --- */
exports.routingBehavior = (0, pg_core_1.pgEnum)("routing_behavior", [
    "REALTIME_EMAIL",
    "CONDITIONAL_CRIT",
    "CRIT_EMAIL_CALL",
    "SUMMARY_ONLY",
    "CALL_ALL",
]);
exports.routingContactScope = (0, pg_core_1.pgEnum)("routing_contact_scope", ["FACILITY", "UNIT"]);
exports.endpointChannel = (0, pg_core_1.pgEnum)("endpoint_channel", ["EMAIL", "PHONE"]);
// INSTRUCTION is prose, never dialled or texted
exports.phoneKind = (0, pg_core_1.pgEnum)("phone_kind", ["VOICE", "SMS", "INSTRUCTION"]);
exports.reachWindow = (0, pg_core_1.pgEnum)("reach_window", ["ALL_TIMES", "DAY_9_5", "NIGHT"]);
exports.reachDays = (0, pg_core_1.pgEnum)("reach_days", ["ALL", "WEEKDAY", "WEEKEND"]);
exports.standingCcScope = (0, pg_core_1.pgEnum)("standing_cc_scope", ["ALERT", "SUMMARY"]);
exports.notificationType = (0, pg_core_1.pgEnum)("notification_type", [
    "ALERT",
    "DAILY_SUMMARY",
    "WEEKLY_SUMMARY",
]);
exports.routingResolutionStatus = (0, pg_core_1.pgEnum)("routing_resolution_status", [
    "ROUTED",
    "UNMET",
    "NO_OBLIGATION",
    "NOT_ROUTED",
]);
exports.summaryKind = (0, pg_core_1.pgEnum)("summary_kind", ["DAILY", "WEEKLY"]);
exports.summaryState = (0, pg_core_1.pgEnum)("summary_state", ["DUE", "SENT"]);
/* --- configuration and audit vocabulary --- */
exports.enrolmentState = (0, pg_core_1.pgEnum)("enrolment_state", ["ENROLLED", "EXEMPT"]);
exports.changeOperation = (0, pg_core_1.pgEnum)("change_operation", ["INSERT", "UPDATE", "DELETE"]);
exports.changeChannel = (0, pg_core_1.pgEnum)("change_channel", [
    "UI",
    "API",
    "SCHEDULED_JOB",
    "IMPORT",
    "MIGRATION",
]);
//# sourceMappingURL=rpm-enums.js.map